import { Avatar, Button, Paper, Tooltip, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import CreateResumeModal from "../components/CreateResumeModal";
import DataTextField from "../components/DataInputs/DataTextField";
import Loader from "../components/Loader";
import usePagination, { InfinityPagination } from "../hooks/Pagination";
import { CandidatePageData } from "../interfaces/Candidate";
import Resume, { ResumeList } from "../interfaces/Resume";
import {
	GetCandidate,
	GetRequest,
	GetRequests,
	GetResume,
	GetResumes,
	GetTask,
	GetTasks,
	GetUserTests,
	UpdateCandidate,
} from "../requester/functions";
import { Pagination } from "../interfaces/RequestBase";
import VO, { getUrlId, VK, VN } from "../utilities/validate";
import { RequestTable } from "../interfaces/Request";
import UpdateRequestModal from "../components/UpdaRequestModal";
import CreateRequestModal from "../components/CreateRequestModal";
import dateToHuman from "../utilities/date";
import CreateTaskModal from "../components/CreateTaskModal";
import { TaskTable } from "../interfaces/Task";
import UpdateTaskModal from "../components/UpdateTaskModal";
import { getStatusColor } from "../utilities/color";
import { UserTest } from "../interfaces/Test";

import CheckBoxIcon from "@mui/icons-material/CheckBox";
import DisabledByDefaultIcon from "@mui/icons-material/DisabledByDefault";
import CommentBox from "../components/CommentBox";

interface IProps {}

const candidateTemplate: CandidatePageData = {
	id: 0,
	full_name: "",
	avatar: "",
	phone: "",
	email: "",
	creation_date: "",
};

const CandidatePage = (props: IProps) => {
	const { enqueueSnackbar } = useSnackbar();
	const navigate = useNavigate();
	const location = useLocation();

	const [pagination, setPage, setPageSize] = usePagination();

	const [openCreate, setOpenCreate] = useState<boolean>(false);
	const [openCreateTask, setOpenCreateTask] = useState<boolean>(false);

	const [isEditable, setIsEditable] = useState<number>(0);
	const [openModal, setOpenModal] = useState<boolean>(false);

	const [localCandidate, setLocalCandidate] =
		useState<CandidatePageData | null>(null);

	const [resumes, setResumes] = useState<ResumeList[]>([]);
	const [selectedResume, setSelectedResume] = useState<Resume>();

	const [requests, setRequests] = useState<RequestTable[]>([]);
	const [selectedRequest, setSelectedRequest] = useState<RequestTable | null>();

	const [tasks, setTasks] = useState<TaskTable[]>([]);
	const [selectedTask, setSelectedTask] = useState<TaskTable | null>();

	const [tests, setTests] = useState<UserTest[]>([]);

	const getRequest = (id: number) => {
		GetRequest({ id }, (resp) => {
			if (resp.status === "ok" && resp.data) {
				setSelectedRequest(resp.data);
			}
		});
	};

	const getResumes = () => {
		if (localCandidate)
			GetResumes(
				{
					filter_by: { id_candidate: localCandidate?.id || 0 },
					pagination: InfinityPagination,
				},
				(resp) => {
					if (resp.status === "ok" && resp.data) {
						setResumes([...resp.data.data]);
					}
				}
			);
	};

	const getRequests = (id: number) => {
		GetRequests(
			{
				filter_by: { id_candidate: id },
				pagination: pagination as Pagination,
			},
			(resp) => {
				if (resp.status === "ok" && resp.data) {
					setRequests(resp.data.data);
				}
			}
		);
	};

	const getTask = (id: number) => {
		GetTask({ id }, (resp) => {
			if (resp.status === "ok" && resp.data) {
				setSelectedTask(resp.data);
			}
		});
	};

	const getTasks = (id: number) => {
		GetTasks(
			{
				filter_by: { id_candidate: id },
				pagination: pagination as Pagination,
			},
			(resp) => {
				if (resp.status === "ok" && resp.data) {
					setTasks(resp.data.data);
				}
			}
		);
	};

	useEffect(() => {
		const idCandidate: string = getUrlId(location.pathname);

		GetCandidate({ id_candidate: parseInt(idCandidate) }, (resp) => {
			if (resp.status === "ok" && resp.data) {
				setLocalCandidate({ ...resp.data });

				getRequests(resp.data.id);
				getTasks(resp.data.id);
				GetUserTests({ id_candidate: resp.data.id }, (resp) => {
					if (resp.status === "ok" && resp.data) {
						setTests(resp.data);
					}
				});
			} else {
				navigate("/candidates");
			}
		});
	}, []);

	useEffect(() => {
		if (isEditable <= 2) setIsEditable(isEditable + 1);
		getResumes();
	}, [localCandidate]);

	return localCandidate ? (
		<div className="flex w-full gap-5 min-h-[84vh] h-full items-stretch">
			<div className="flex flex-col gap-5 w-[300px]">
				<Paper className="p-3 min-w-[256px] flex flex-col gap-2">
					<Avatar
						className="mx-auto"
						sx={{ width: "150px", height: "150px" }}
						src={localCandidate.avatar}
					/>
					<DataTextField
						value={localCandidate}
						setValue={setLocalCandidate}
						keyValue={"full_name"}
						inputProps={{
							label: "ФИО",
							error: !VN(localCandidate.full_name),
						}}
					/>
					<DataTextField
						value={localCandidate}
						setValue={setLocalCandidate}
						keyValue={"email"}
						inputProps={{
							label: "Почта",
							error: !VK(localCandidate.email),
						}}
					/>
					<DataTextField
						value={localCandidate}
						setValue={setLocalCandidate}
						keyValue={"phone"}
						inputProps={{
							label: "Телефон",

							error: !VK(localCandidate.phone),
						}}
					/>
					<Typography>
						Зарегистрирован: {dateToHuman(localCandidate.creation_date)}
					</Typography>
					{isEditable > 2 ? (
						<Button
							variant="contained"
							disabled={
								!VO(localCandidate, candidateTemplate) ||
								!VN(localCandidate.full_name)
							}
							onClick={() => {
								UpdateCandidate(localCandidate, (resp) => {
									if (resp.status === "ok") {
										enqueueSnackbar("Пользователь обновлен", {
											variant: "success",
										});
										setIsEditable(2);
									} else {
										enqueueSnackbar(`Ошибка ${resp.code}, ${resp.message}`, {
											variant: "error",
										});
									}
								});
							}}
						>
							Сохранить
						</Button>
					) : null}
				</Paper>
				<Paper className="p-3 flex flex-col gap-2">
					<Typography variant={"h6"}>Направления</Typography>
					<div className="flex gap-2 w-full overflow-x-auto">
						{localCandidate.directions
							? localCandidate.directions.map((d, i) => (
									<Paper
										key={`directions-${i}`}
										className="!rounded-full py-2 px-3 !bg-[#42A5F5] !text-white"
									>
										{d.name}
									</Paper>
							  ))
							: null}
					</div>
				</Paper>
			</div>
			<div className="flex items-start gap-5  ">
				<Paper className="px-2 py-1 h-full w-[300px]">
					<Typography variant="h6" className="text-center">
						Заявки
					</Typography>
					<div className="flex flex-col w-full">
						{requests.map((r, i) => (
							<Paper
								key={`request-${i}`}
								elevation={3}
								className="flex justify-between items-center p-2 mb-2 cursor-pointer"
								onClick={() => {
									getRequest(r.id);
								}}
							>
								<div>{r.vacancy.name}</div>
								<div className="flex flex-col gap-1">
									<Paper
										className="!px-2 !rounded-full !text-white"
										style={{
											backgroundColor: getStatusColor(r.status.id),
										}}
									>
										{r.status.name}
									</Paper>
									<div className="text-sm">{dateToHuman(r.creation_date)}</div>
								</div>
							</Paper>
						))}
					</div>
					<Button
						variant="contained"
						className="mx-auto"
						onClick={() => {
							setOpenCreate(true);
						}}
					>
						{" "}
						Создать{" "}
					</Button>
				</Paper>
				<Paper className="px-2 py-1 h-full  w-[300px]">
					<Typography variant="h6" className="text-center">
						Резюме
					</Typography>
					<div className="flex flex-col w-full overflow-y-auto max-h-[500px] ">
						{resumes.map((r, i) => {
							return (
								<Paper
									key={`resume-${i}`}
									elevation={3}
									className="flex items-center p-2 mb-2 cursor-pointer"
									onClick={() => {
										GetResume({ id: r.id }, (resp) => {
											if (resp.status === "ok" && resp.data) {
												setSelectedResume(resp.data);
											}
										});
									}}
								>
									Резюме - {dateToHuman(r.creation_date || 0)}
								</Paper>
							);
						})}
					</div>
					<Button
						variant="contained"
						className="mx-auto"
						onClick={() => {
							setSelectedResume(undefined);
							setOpenModal(true);
						}}
					>
						{" "}
						Создать{" "}
					</Button>
				</Paper>
				<Paper className="px-2 py-1 h-full w-[300px]">
					<Typography variant="h6" className="text-center">
						Задачи
					</Typography>
					<div className="flex flex-col w-full">
						{tasks.map((r, i) => (
							<Paper
								key={`request-${i}`}
								elevation={3}
								className="flex items-center p-2 mb-2 cursor-pointer"
								onClick={() => {
									getTask(r.id);
								}}
							>
								{r.name}
							</Paper>
						))}
					</div>
					<Button
						variant="contained"
						className="mx-auto"
						onClick={() => {
							setOpenCreateTask(true);
						}}
					>
						{" "}
						Создать{" "}
					</Button>
				</Paper>
				<Paper className="px-2 py-1 h-full w-[300px]">
					<Typography variant="h6" className="text-center">
						Тесты
					</Typography>
					<div className="flex flex-col w-full">
						{tests.map((t, i) => (
							<Link to={`/test/${t.test.id}/${localCandidate.id}`}>
								<Paper
									key={`test-${i}`}
									className="flex items-center p-2 mb-2  cursor-pointer"
								>
									<div className="flex flex-col w-full">
										<div className="flex justify-between w-full items-center">
											<Typography>{t.test.name}</Typography>
											{t.verifed_manager ? (
												<Tooltip title={t.verifed_manager.full_name}>
													<Avatar src={t.verifed_manager.avatar} />
												</Tooltip>
											) : null}
										</div>
										{t.result ? (
											!t.status ? (
												<Typography>Не проверен</Typography>
											) : (
												<div className="flex gap-2 items-center">
													{t.confirmed ? (
														<CheckBoxIcon color="success" />
													) : (
														<DisabledByDefaultIcon color="error" />
													)}

													<Typography>
														{t.confirmed ? "Сдано" : "Провалено"}
													</Typography>
												</div>
											)
										) : (
											<Typography>Не пройден</Typography>
										)}
									</div>
								</Paper>
							</Link>
						))}
					</div>
				</Paper>
				<div className="max-h-[75vh]">
					<CommentBox id_obj={localCandidate.id} type="candidate" />
				</div>
			</div>
			<CreateResumeModal
				open={selectedResume || openModal ? true : false}
				resume={selectedResume}
				userId={localCandidate.id}
				onClose={(isUpdate: boolean) => {
					if (isUpdate) getResumes();

					setSelectedResume(undefined);
					setOpenModal(false);
				}}
				user={localCandidate}
			/>
			<UpdateRequestModal
				open={selectedRequest != null}
				onClose={(isUpdate?: boolean) => {
					if (isUpdate) getRequests(localCandidate.id);
					setSelectedRequest(null);
				}}
				request={selectedRequest || undefined}
				userId={localCandidate.id}
				onUpdate={(id) => {
					getRequest(id);
				}}
			/>
			<UpdateTaskModal
				open={selectedTask != null}
				onClose={(isUpdate?: boolean) => {
					if (isUpdate) getTasks(localCandidate.id);
					setSelectedTask(null);
				}}
				task={selectedTask || undefined}
				userId={localCandidate.id}
				onUpdate={(id) => {
					getTask(id);
				}}
			/>
			<CreateRequestModal
				open={openCreate}
				onClose={() => {
					setOpenCreate(false);
				}}
				userId={localCandidate.id}
				onCreate={() => {
					getRequests(localCandidate.id);
				}}
			/>
			<CreateTaskModal
				open={openCreateTask}
				onClose={() => {
					setOpenCreateTask(false);
				}}
				userId={localCandidate.id}
				onCreate={() => {
					getTasks(localCandidate.id);
				}}
			/>
		</div>
	) : (
		<Loader />
	);
};

export default CandidatePage;
